export default __webpack_public_path__ + "static/media/fross4.2b83e8a6.png";